var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "data-loading"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loaderBar"
  })])]);

}]

export { render, staticRenderFns }